package org.matthewo.pages.event.tabs

import org.matthewo.api.EventCompetition
import org.matthewo.api.MetricsAPI
import org.matthewo.pages.event.EventTabFC
import org.matthewo.routes.API
import org.matthewo.table.games.RecordsTableGeneric

val EventRecordsTable = EventTabFC<API.Event.Records, List<EventCompetition<Short, MetricsAPI<Short>?>>>({
    API.Event.Records(it)
}) { (coroutineScope, year, eventCode, data) ->
    RecordsTableGeneric(year, data ?: []) {
        sortableByTeam = true
        event = eventCode
    }
}
